import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import AlertMixin from '@/mixins/alert';
import template from '@/../templates/standard-list-layout.hbs';

var globalCh = Radio.channel('global');

export default Marionette.View.extend(AlertMixin).extend({
    className: 'standard-layout',
    template: Handlebars.compile(template),
    ui: {
        bulk_controls: '.controls > .group',
        pagination_controls: '.controls > .pagination',
        controls: '.controls',
        create_item: '.create-item-region',
        alerts: '.alerts',
        content: '.content-region',
        blinkup_page: '.blinkup-page'
    },
    regions: {
        bulk_controls: '@ui.bulk_controls',
        pagination_controls: '@ui.pagination_controls',
        controls: '@ui.controls',
        create_item: '@ui.create_item',
        alerts: '@ui.alerts',
        content: '@ui.content'
    },
    events: {
        'click @ui.blinkup_page': function(e) { // to show blinkup from the button
            e.preventDefault();
            globalCh.request('show_blinkup');
        }
    },
    initialize: function() {
        globalCh.reply('layout_alert', this.alert.bind(this));
    },
    templateContext: function() {
        return {
            title: this.getOption('title') || 'Untitled',
            // In the case we are not wanting to show the
            // controls region, ie, no pagination, no buttons
            // in the group div. If no_controls evaluates to
            // true, the controls region will have a class
            // added to it.
            no_controls: this.getOption('no_controls') || false,
            show_blinkup: this.getOption('show_blinkup') || false
        };
    }
});

